
import store from '@/store';
import { defineComponent } from 'vue';
import { useRouter } from 'vue-router';
import { mdiChevronRight } from '@mdi/js';

export default defineComponent({
  setup() {
    const router = useRouter();

    const acceptInvite = () => {
      store.dispatch('addNotification', { type: 'sucess', message: 'Willkommen!' });
      router.push({ name: 'Index' });
    };

    return {
      mdiChevronRight,
      acceptInvite,
      params: router.currentRoute.value.params,
    };
  },
});
